<template>
	<div class="Outsourcing">
		<div class="partOne">
			<div class="bb">
				<div class="innerBox">
					<div class="title">
						<div style="display: flex;align-items: center;">
							<p style="margin-right: 20px;">谋生活外包</p>
							<p style="font-size: 22px;font-weight: lighter;">专注于现代服务业的酒店餐饮服务外包平台</p>
						</div>
						<div class="url">61MSH.COM</div>
					</div>
					<div class="Box">
						<div class="partner-title">
							<div class="url">61MSH.COM</div>
							<div class="one">
								<span class="frozen" data-heading="Frozen">谋生活外包</span>
								<span>/</span>
								<span
									style="font-size: 22px;color: #666;font-family: 'frozen', serif;">复杂的、稳定的、时间长的业务用谋生活服务外包</span>
							</div>
							<div class="two"></div>
							<div class="three">
								基于互联网、云计算、大数据和人工智能领域的计算机技术应用，实现用工信息智能匹配，帮助工人快速找到合适工作，提供科学化考勤管理和薪资结算。在保障就业者权益的前提下，构建线上线下相融合的现代服务业外包服务平台
							</div>
						</div>
						<!-- <div class="slider">
							<el-carousel :interval="5000" arrow="always">
								<el-carousel-item>
									<img src="../assets/images/banner/bg_1.png" height="585px" width="352px"
										style="margin-top: 2vw;" />
								</el-carousel-item>
								<el-carousel-item>
									<img src="../assets/images/banner/bg_1.png" height="585px" width="352px"
										style="margin-top: 2vw;" />
								</el-carousel-item>
							</el-carousel>
						</div> -->
						<div class="slider">
							<ul>
								<li v-for="(item,index) in BannerList" :key="index" v-show="listIndex===index"
									@mouseover="changeMouse(true)" @mouseleave="changeMouse(false)">
									<a href="">
										<img :src="item.BannerUrl" alt="" height="585px" width="352px">
									</a>
								</li>
							</ul>
							<!-- <img src="../assets/images/banner/bg_1.png" height="585px" width="352px" style="margin-top: 2vw;"/>
							<img src="../assets/images/banner/bg_2.png" height="585px" width="352px" style="margin-top: 2vw;"/> -->
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="textcenter">
			<div class="tc-phone">
				<div style="margin: 0 15px;"><i class="fa fa-phone" style="font-size: 25px;font-style: normal;"></i>
				</div>
				<span>400-700-9161</span>
			</div>
			<h3>
				灵活就业及企业用工灵活化服务SaaS服务平台
			</h3>
		</div>
		<div class="partTwo">
			<div class="inner-box">
				<div class="p-top">
					<h4>将企业服务外包临时化的SaaS平台</h4>
				</div>
				<div class="titles a">
					<div class="ts-item">
						<span class="div5 f1">费控</span>
						<p>降低用工成本</p>
					</div>
					<div class="ts-item">
						<span class="div5 f2">协同</span>
						<p>提高用工效率</p>
					</div>
					<div class="ts-item">
						<span class="div5 f3">风险</span>
						<p>规避用工风险</p>
					</div>
				</div>
				<div class="isInUp">
					<div class="is-item spin1">
						<img src="../assets/images/img/ygjh.png" alt="" style="width: 100px;">
						<h4>用工计划</h4>
						<p>
							全面预测用工需求，用工申请、审批的一体化，对接谋生活招聘平台！
						</p>
					</div>
					<div class="is-item spin2">
						<img src="../assets/images/img/yggy.png" alt="" style="width: 100px;">
						<h4>用工供应</h4>
						<p>
							对接谋生活、打造招聘门户、建立用工池，随时取用，打造用工供应系统！
						</p>
					</div>
					<div class="is-item spin3">
						<img src="../assets/images/img/zpxz.png" alt="" style="width: 100px;">
						<h4>招聘协作</h4>
						<p>
							工人实时接单、平台送人同步协同操作，同时要在线对账核算，高效快捷！
						</p>
					</div>
					<div class="is-item spin4">
						<img src="../assets/images/img/yggl.png" alt="" style="width: 100px;">
						<h4>用工管理</h4>
						<p>
							AI智能移动端考勤、工时全流程管控，人员实名制管理，智能排班解决企业对员工复杂的排班系统，高度灵活调配人力，按需分配，实现多渠道招工、多方式协同管控。
						</p>
					</div>
					<div class="is-item spin5">
						<img src="../assets/images/img/fygl.png" alt="" style="width: 100px;">
						<h4>费用管理</h4>
						<p>
							工资实时计算、费用在线核算，高效快捷的用工协作，员工随时结算提现工资，谋生活平台按月与企业结算费用！
						</p>
					</div>
					<div class="is-item spin6">
						<img src="../assets/images/img/ygfx.png" alt="" style="width: 100px;">
						<h4>用工分析</h4>
						<p>
							用工过程详细展现各类数据报表，分析用工效率，全局的数据化管控！系统自动形成账户资金、打款明细以及结算数据等可视化报表，有助于企业对结算数据的管理和分析。
						</p>
					</div>
				</div>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'Outsourcing',
		data() {
			return {
				BannerList: [{
						BannerUrl: require("../assets/images/banner/bg_1.png"),
						id: 1
					},
					{
						BannerUrl: require("../assets/images/banner/bg_2.png"),
						id: 2
					},
				],
				listIndex: 0,
				timer: null,
			}
		},
		created() {
			this.setTimer();
		},
		methods: {
			setTimer() {
				clearInterval(this.timer);
				this.timer = setInterval(() => {
					this.listIndex++;
					if (this.listIndex == this.BannerList.length) {
						this.listIndex = 0
					}
				}, 5000)
			},
			changeMouse(mouser) {
				if (mouser) {
					clearInterval(this.timer)
				} else {
					this.setTimer()
				}
			}
		}
	}
</script>
<style scoped>
	/* .el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	} */


	/* 设置自定义字体 */
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}

	.frozen {
		/* 最初字体样式 */
		font-size: 30px;
		font-weight: 400;
		margin-left: 20px;
		/* 使用自定义字体 */
		/* font-family: "frozen", serif; */
		/* 设置背景图片 */
		/* background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/6963bbf342d87b3a2150bd8f59682b89.jpg); */
		/* 设置文字透明且背景按文字区域裁剪 */
		/* color: transparent; */
		color: #252627;
		-webkit-background-clip: text;
		/* 为了子元素定位 */
		position: relative;
	}

	.frozen::before {
		/* 获取自定义属性文字 */
		content: attr(data-heading);
		/* 使其和父元素文字重叠 */
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		/* 使用颜色混合模式 */
		mix-blend-mode: screen;
		/* 文字透明 */
		color: transparent;
		/* 设置文字阴影 */
		text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2), -2px 2px 10px rgba(0, 0, 0, 0.2), -2px -2px 10px rgba(0, 0, 0, 0.2);
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}

	/* 设置背景图动画 */
	@keyframes glare {
		0% {
			background-position: -100%;
		}

		100% {
			background-position: 100%;
		}
	}

	.Outsourcing {
		background-color: rgb(255, 255, 255);
		height: 100%;
		margin-top: 50px;
	}

	.partOne {
		height: 100%;
		height: 720px;
		background-color: #f9fafc;
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 0 0 2%;
	}

	.partOne .bb {
		width: 100%;
		flex: 1 1;
		background-color: #fff;
	}

	.partOne .innerBox {
		width: 1200px;
		margin: 0 auto;
	}

	.partOne .innerBox .title {
		width: 1220px;
		height: 80px;
		box-shadow: 0 0px 10px 7px #eff2f8;
		margin-left: -10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 28px;
		padding: 0 20px;
		border-radius: 12px;
	}

	.url {
		font-family: "frozen", serif;
		font-size: 43px;
		-webkit-text-stroke: 1px #ff8500;
		-webkit-text-fill-color: white;
		color: white;
		opacity: 0.5;
		margin: 10px 20px;
	}

	.partOne .innerBox .Box {
		display: flex;
		align-items: center;
		justify-content: space-around;
		/* margin-top: 10%; */
	}

	.partOne .innerBox .Box .partner-title {
		margin-top: 13%;
		width: 1100px;
		height: 370px;
		background: #fff;
		box-shadow: 0 0px 16px 2px #eff2f8;
		border-radius: 10px;
		padding: 30px 0 30px 10px;
		box-sizing: border-box;
	}

	.partOne .innerBox .Box .partner-title .two {
		top: 10px;
		width: 374px;
		height: 1px;
		background-image: linear-gradient(269deg, #ff8500, rgba(255, 133, 0, 0));
		margin-left: 300px;
		margin-bottom: 20px;
		position: relative;
	}

	.partOne .innerBox .Box .partner-title .two::before {
		width: 9px;
		height: 9px;
		background: #ff8500;
		content: "";
		position: absolute;
		top: -4px;
		right: 0;
	}

	.partOne .innerBox .Box .partner-title .three {
		width: 672px;
		height: 120px;
		/* font-family: PingFangSC-Light; */
		font-size: 16px;
		color: #252627;
		line-height: 40px;
		font-weight: 200;
		text-indent: 2em;
		margin: 30px 25px 10px;
	}

	.partOne .innerBox .Box .slider {
		margin-top: 5%;
		width: 395px;
		height: 640px;
		margin-left: 760px;
		background-image: url(../assets/images/img/iphone-bg.png);
		background-size: 395px 640px;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		right: 20%;
		top: 0;
		animation: contentFromRight2Left .6s ease-out;
	}

	/* .partOne .innerBox .Box .sliderBox {
		margin-top: 5%;
		width: 432px;
		height: 641px;
		margin-left: 650px;
		background-image: url(../assets/images/img/iphone-bg.png);
		background-size: 432px 640px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		right: 19%;
		top: 0;
		-webkit-animation: contentFromRight2Left .6s ease-out;
		animation: contentFromRight2Left .6s ease-out;
	}

	.partOne .innerBox .Box .sliderBox .box {
		width: 362px;
		height: 669px;
	}

	.slick-list,
	.slick-slider {
		position: relative;
		display: block;
	}

	.slick-slider {
		box-sizing: border-box;
		-webkit-user-select: none;
		user-select: none;
		-webkit-touch-callout: none;
		-khtml-user-select: none;
		touch-action: pan-y;
		-webkit-tap-highlight-color: transparent;
	}

	.slick-prev {
		left: -25px;
	}

	.slick-next,
	.slick-next:focus,
	.slick-next:hover,
	.slick-prev,
	.slick-prev:focus,
	.slick-prev:hover {
		color: transparent;
		outline: none;
		background: transparent;
	}

	.slick-next,
	.slick-prev {
		font-size: 0;
		line-height: 0;
		position: absolute;
		top: 50%;
		display: block;
		width: 20px;
		height: 20px;
		padding: 0;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		cursor: pointer;
		border: none;
	}

	.slick-list {
		overflow: hidden;
		margin: 0;
		padding: 0;
	}

	.slick-track {
		position: relative;
		top: 0;
		left: 0;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}

	.slick-track::after,
	.slick-track::before {
		display: table;
		content: "";
	}

	.slick-slide {
		display: none;
		float: left;
		height: 100%;
		min-height: 1px;
	}

	.banner1,
	.banner2 {
		width: 362px;
		height: 669px;
		background-position: 50%;
		background-size: 362px 669px;
		background-repeat: no-repeat;
	}

	.banner1 {
		background-image: url('../assets/images/banner/bg_1.png');
	}

	.banner2 {
		background-image: url('../assets/images/banner/bg_2.png');
	}
 */


	.textcenter {
		background-color: #ff8400;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}

	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}

	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}

	.partTwo {
		padding: 80px 0;
		background: #fff;
	}

	.partTwo .p-top {
		text-align: center;
	}

	.partTwo .p-top h4 {
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #222426;
		line-height: 48px;
	}

	.partTwo .titles {
		display: flex;
	}

	.partTwo .titles .ts-item {
		flex-basis: 33.33%;
		text-align: center;
		margin-top: 80px;
	}

	.div5 {
		width: 100px;
		height: 100px;
		display: block;
		text-align: center;
		line-height: 100px;
		position: relative;
		color: #fff;
		/* border: 2px solid #ff8500; */
		border-radius: 50%;
		font-size: 25px;
		margin: 0 auto;
		margin-bottom: 20px;
		transition: all .3s;
	}

	.div5:hover {
		transform: rotateY(360deg);
		-webkit-transition: -webkit-transform 1s ease-out;
		-moz-transition: -webkit-transform 1s ease-out;
		-o-transition: -webkit-transform 1s ease-out;
	}

	.f1 {
		background: #54B9EC;
	}

	.f2 {
		background: #FF9966;
	}

	.f3 {
		background: #FF6666;
	}

	/* .div5::before {
		content: "";
		position: absolute;
		top: -5px;
		left: -5px;
		right: -5px;
		bottom: -5px;
		border: 2px solid rgba(168, 239, 255, 1);
		border-radius: 50px;
		animation: div5Ani 3s infinite linear;
	}
	
	@keyframes div5Ani {
		0%,
		    100% {
		        clip-path: inset(0 0 95% 0);
		    }
		    25% {
		        clip-path: inset(0 95% 0 0);
		    }
		    50% {
		        clip-path: inset(95% 0 0 0);
		    }
		    75% {
		        clip-path: inset(0 0 0 95%);
		    }
	} */
	.partTwo .isInUp {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 40px;
	}

	.partTwo .isInUp .is-item {
		padding: 40px 0 30px;
		width: 32.5%;
		background: #fff;
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
		border-radius: 4px;
		margin-top: 40px;
		position: relative;
		overflow: hidden;
		text-align: center;
		/* vertical-align: middle; */
	}

	.partTwo .isInUp .is-item:hover img {
		transform: rotateY(360deg);
		-webkit-transition: -webkit-transform 1s ease-out;
		-moz-transition: -webkit-transform 1s ease-out;
		-o-transition: -webkit-transform 1s ease-out;
	}

	.partTwo .isInUp .spin1:hover {
		border: 2px solid #ffcccc;
		border-top-color: #ffcccc;
		border-right-color: #ffcccc;
		border-bottom-color: #ffcccc;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .spin2:hover {
		border: 2px solid #ffb3ff;
		border-top-color: #ffb3ff;
		border-right-color: #ffb3ff;
		border-bottom-color: #ffb3ff;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .spin3:hover {
		border: 2px solid #99ffbb;
		border-top-color: #99ffbb;
		border-right-color: #99ffbb;
		border-bottom-color: #99ffbb;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .spin4:hover {
		border: 2px solid #b3e6ff;
		border-top-color: #b3e6ff;
		border-right-color: #b3e6ff;
		border-bottom-color: #b3e6ff;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .spin5:hover {
		border: 2px solid #ffd480;
		border-top-color: #ffd480;
		border-right-color: #ffd480;
		border-bottom-color: #ffd480;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .spin6:hover {
		border: 2px solid #ccffff;
		border-top-color: #ccffff;
		border-right-color: #ccffff;
		border-bottom-color: #ccffff;
		transition: border-top-color 0.15s linear, border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
	}

	.partTwo .isInUp .is-item h4 {
		margin: 30px 0 20px;
		font-size: 20px;
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		color: #222426;
		line-height: 28px;
	}

	.partTwo .isInUp .is-item p {
		padding: 0 20px;
		text-align: left;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 14px;
		/* font-family: PingFangSC-Regular, PingFang SC; */
		font-weight: 400;
		color: #666666;
		line-height: 28px;
	}

	.partTwo .isInUp .is-item .line {
		margin-top: 36px;
		width: 100%;
		height: 4px;
		background: #ff8500;
		border-radius: 4px;
	}
</style>
<!-- <style scoped>
	/* 设置自定义字体 */
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}

	.frozen {
		/* 最初字体样式 */
		font-size: 30px;
		font-weight: 400;
		margin-left: 20px;
		/* 使用自定义字体 */
		/* font-family: "frozen", serif; */
		/* 设置背景图片 */
		/* background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/6963bbf342d87b3a2150bd8f59682b89.jpg); */
		/* 设置文字透明且背景按文字区域裁剪 */
		/* color: transparent; */
		color: #252627;
		-webkit-background-clip: text;
		/* 为了子元素定位 */
		position: relative;
	}

	.frozen::before {
		/* 获取自定义属性文字 */
		content: attr(data-heading);
		/* 使其和父元素文字重叠 */
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		/* 使用颜色混合模式 */
		mix-blend-mode: screen;
		/* 文字透明 */
		color: transparent;
		/* 设置文字阴影 */
		text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2), -2px 2px 10px rgba(0, 0, 0, 0.2), -2px -2px 10px rgba(0, 0, 0, 0.2);
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}

	/* 设置背景图动画 */
	@keyframes glare {
		0% {
			background-position: -100%;
		}

		100% {
			background-position: 100%;
		}
	}

	.glare {
		/* 初始样式 */
		width: 500px;
		height: 300px;
		border: 1px solid #333;
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.8) 50%, rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}


	.Outsourcing {
		background-color: rgb(255, 255, 255);
		height: calc(100vh - 80px);
		margin-top: 80px;
	}

	.partOne {
		height: 100%;
		background-color: #f9fafc;
		display: flex;
		flex-direction: column;
		position: relative;
		margin: 0 0 2%;
	}

	.partOne .innerBox {
		width: 1200px;
		/* height: 690px; */
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -600px;
		margin-top: -345px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.partOne .bb {
		width: 100%;
		flex: 1 1;
		background-color: #fff;
	}

	.partOne .innerBox .title {
		width: 1220px;
		height: 80px;
		box-shadow: 0 0px 10px 7px #eff2f8;
		margin-left: -10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 28px;
		padding: 0 20px;
		border-radius: 12px;
	}

	.url {
		font-family: "frozen", serif;
		font-size: 43px;
		-webkit-text-stroke: 1px #ff8500;
		-webkit-text-fill-color: white;
		color: white;
		opacity: 0.5;
		margin: 10px 20px;
	}

	.partOne .innerBox .Box {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-top: 10%;
	}

	.partOne .innerBox .Box .partner-title {
		margin-top: 80px;
		width: 1100px;
		height: 370px;
		background: #fff;
		box-shadow: 0 0px 16px 2px #eff2f8;
		border-radius: 10px;
		padding: 30px 0 30px 10px;
		box-sizing: border-box;
	}

	.partOne .innerBox .Box .partner-title .two {
		top: 10px;
		width: 374px;
		height: 1px;
		background-image: linear-gradient(269deg, #ff8500, rgba(255, 133, 0, 0));
		margin-left: 300px;
		margin-bottom: 20px;
		position: relative;
	}

	.partOne .innerBox .Box .partner-title .two::before {
		width: 9px;
		height: 9px;
		background: #ff8500;
		content: "";
		position: absolute;
		top: -4px;
		right: 0;
	}

	.partOne .innerBox .Box .partner-title .three {
		width: 672px;
		height: 120px;
		/* font-family: PingFangSC-Light; */
		font-size: 16px;
		color: #252627;
		line-height: 40px;
		font-weight: 200;
		text-indent: 2em;
		margin: 30px 25px 10px;
	}

	.partOne .innerBox .Box .slider {
		margin-top: 10%;
		width: 395px;
		height: 640px;
		margin-left: 760px;
		background-image: url(https://cdn.hrwork.com/fore/duomi-official-pc/publish/build/static/media/iphone-bg.3b5cb411.png);
		background-size: 395px 640px;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		right: 0;
		top: 0;
		animation: contentFromRight2Left .6s ease-out;
	}

	.textcenter {
		background-color: #f7d375;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}

	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}

	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}

	.partTwo {
		padding: 80px 0;
		background: #fff;
	}

	.partTwo .p-top {
		text-align: center;
	}

	.partTwo .p-top h4 {
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #222426;
		line-height: 48px;
	}

	.partTwo .titles {
		display: flex;
	}

	.partTwo .titles .ts-item {
		flex-basis: 33.33%;
		text-align: center;
		margin-top: 80px;
	}

	.div5 {
		width: 100px;
		height: 100px;
		display: block;
		text-align: center;
		line-height: 100px;
		position: relative;
		color: #fff;
		/* border: 2px solid #ff8500; */
		border-radius: 50%;
		font-size: 25px;
		margin: 0 auto;
		margin-bottom: 20px;
		transition: all .3s;
	}

	.f1 {
		background: #54B9EC;
	}

	.f2 {
		background: #FF9966;
	}

	.f3 {
		background: #FF6666;
	}
	
	/* .div5 {
	    position: relative;
	 
	    &::before {
	        content: "";
	        position: absolute;
	        top: 0;
	        left: 0;
	        right: 0;
	        bottom: 0;
	        border: 2px solid gold;
	        animation: clippath 3s infinite linear;
	    }
	} */
	
	.div5::before {
		content: "";
		position: absolute;
		top: -5px;
		left: -5px;
		right: -5px;
		bottom: -5px;
		border: 2px solid rgba(168, 239, 255, 1);
		border-radius: 50px;
		animation: div5Ani 3s infinite linear;
	}

	@keyframes div5Ani {
		0%,
		    100% {
		        clip-path: inset(0 0 95% 0);
		    }
		    25% {
		        clip-path: inset(0 95% 0 0);
		    }
		    50% {
		        clip-path: inset(95% 0 0 0);
		    }
		    75% {
		        clip-path: inset(0 0 0 95%);
		    }
	}
	.partTwo .isInUp {
	  display: flex;
	  flex-wrap: wrap;
	  justify-content: space-between;
	  margin-top: 40px;
	}
	.partTwo .isInUp .is-item {
	  padding: 40px 0 30px;
	  width: 32.5%;
	  background: #fff;
	  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
	  border-radius: 4px;
	  margin-top: 40px;
	  position: relative;
	  overflow: hidden;
	  text-align: center;
	}
	.partTwo .isInUp  .is-item h4 {
	  margin: 30px 0 20px;
	  font-size: 20px;
	  /* font-family: PingFangSC-Medium, PingFang SC; */
	  font-weight: 500;
	  color: #222426;
	  line-height: 28px;
	}
	.partTwo .isInUp .is-item p {
	  padding: 0 20px;
	  text-align: left;
	  display: -webkit-box;
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 2;
	  overflow: hidden;
	  font-size: 14px;
	  /* font-family: PingFangSC-Regular, PingFang SC; */
	  font-weight: 400;
	  color: #666666;
	  line-height: 28px;
	}
	.partTwo .isInUp .is-item .line {
	  margin-top: 36px;
	  width: 100%;
	  height: 4px;
	  background: #ff8500;
	  border-radius: 4px;
	}
	
</style> -->



// WEBPACK FOOTER //
// src/page/Outsourcing.vue